import {nanoid} from 'nanoid'
import moment from 'moment'
export const initialState = {
    taskId: nanoid(),
    dueTime: 4, //plazo en días apra completar la tarea
    dueDate: moment().add(4, 'days'),
    isCreated: false 
};
export const initialStateMulti = [];
export default {initialState, initialStateMulti}